import { graphql } from '@/gql/codegen/gql';
import { useMutation } from '@apollo/client';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

export const SELECT_USER_ENROLLMENT_MUTATION = graphql(/* GraphQL */ `
  mutation EmbaSelectUserEnrollment($input: SelectUserEnrollmentMutationInput!) {
    embaSelectUserEnrollment(input: $input) {
      success
    }
  }
`);

export const useSelectUserEnrollment = () => {
  const navigate = useNavigate();
  const [
    selectUserEnrollmentMutation,
    {
      error: selectUserEnrollmentMutationError,
      loading: selectUserEnrollmentMutationLoading,
    },
  ] = useMutation(SELECT_USER_ENROLLMENT_MUTATION, {});

  const selectUserEnrollment = useCallback(
    async (embaUserEnrollmentId: string): Promise<void> => {
      await selectUserEnrollmentMutation({
        variables: {
          input: {
            embaUserEnrollmentId,
          },
        },
      });

      navigate({
        to: '/',
      });
    },
    [selectUserEnrollmentMutation, navigate],
  );

  return {
    selectUserEnrollment,
    selectUserEnrollmentMutationError,
    selectUserEnrollmentMutationLoading,
  };
};
